import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { TwoFactorStore } from '../stores/twoFactorStore';

export const useTwoFactorStore = () =>
  useContext<{
    twoFactorStore: TwoFactorStore;
  }>(StoreContext);
